import SubFormRenderer from './SubFormRenderer'
import { LayoutRowType, SUBFORM_ADD_BUTTON_BEHAVIOR_CONSTANT } from '@app-store'
import { SubFormRenderWrapperProps } from '../types/formRenderer.types'

// Component not in use now will be modify and use later
const SubFormRenderWrapper = ({
  parentFormKeyName,
  methods,
  mode,
  reregisterKey,
  formUniqueId,
  row,
  fullLayout,
}: SubFormRenderWrapperProps) => {
  const transformRow = (): LayoutRowType => {
    const addedFields =
      fullLayout?.layout_data?.added_fields?.[
        row?.lookup_meta?.lookup_keyName ?? ''
      ]
    return {
      label: row.label,
      rowId: row?.rowId,
      columns: row?.columns ?? [],
      rowType: 'sub-form',
      lookup_meta: {
        id: null,
        lookup_keyName: row?.lookup_meta?.lookup_keyName ?? '',
        type: 'multi lookup',
        mapped_as: addedFields?.db_data_type ?? '',
        layout_type: 'EDIT_MODE',
      },
      initial_count: 1,
      add_button_behavior: SUBFORM_ADD_BUTTON_BEHAVIOR_CONSTANT.DISABLED_ADD,
      relation_identifier: addedFields?.relationship?.relation_identifier,
    }
  }

  const transformedRow = transformRow()
  return (
    <SubFormRenderer
      parentFormKeyName={parentFormKeyName}
      key={transformedRow.rowId}
      row={transformedRow}
      layout={fullLayout}
      mode={mode}
      methods={methods}
      isMultiLookup={true}
      defaultExpandedCount={
        transformedRow.add_button_behavior ===
        SUBFORM_ADD_BUTTON_BEHAVIOR_CONSTANT.DISABLED_ADD
          ? transformedRow.initial_count
          : 1
      }
      maxExpandedCount={transformedRow.initial_count}
      reregisterKey={reregisterKey}
      formUniqueId={formUniqueId}
    />
  )
}

export default SubFormRenderWrapper
